import {
  GET_DELIVERY_SHEET,
  GetRequest,
  GetResultObject
} from "../../../utils/API";

const TYPES = {
  REQUEST_DELIVERY_SHEET: "REQUEST_DELIVERY_SHEET",
  REQUEST_DELIVERY_SHEET_SUCCESS: "REQUEST_DELIVERY_SHEET_SUCCESS",
  REQUEST_DELIVERY_SHEET_FAILED: "REQUEST_DELIVERY_SHEET_FAILED",

  UPDATE_SHEET_LIST: 'UPDATE_SHEET_LIST',
};

const getDeliverySheet = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_DELIVERY_SHEET,
      payload: {},
    });

    GetRequest(GET_DELIVERY_SHEET, params).then(result=> {
      GetResultObject(result, 'data.content', 200, (datas, {pages, size, total}) => {
        dispatch({
          type: TYPES.REQUEST_DELIVERY_SHEET_SUCCESS,
          payload: {data: datas, pages, size, total},
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_DELIVERY_SHEET_FAILED,
        payload: {error},
      });
    });
  }
}

export default {
  getDeliverySheet,
  TYPES,
};
